"use client";

import classNames from "classnames";
import { ReactNode, FC, PropsWithChildren, forwardRef, RefAttributes } from "react";
import Loading from "components/base/loading/Loading";
import styles from "./casino-widget-container.module.sass";

type Props = {
    renderHeader?: ReactNode;
    expanded?: boolean;
    height?: number;
    loading?: boolean;
    wrapperClassName?: string;
    contentContainerClassName?: string;
    contentClassName?: string;
    headerClassName?: string;
    variantClassName?: string;
};

const CasinoWidgetContainer: FC<Props & PropsWithChildren & RefAttributes<HTMLDivElement>> =
    forwardRef(
        (
            {
                renderHeader,
                children,
                expanded,
                height,
                loading,
                wrapperClassName,
                contentContainerClassName,
                headerClassName,
                contentClassName,
            },
            ref,
        ) => {
            return (
                <div
                    style={height ? { minHeight: height } : undefined}
                    className={classNames(
                        styles.widget,
                        wrapperClassName,
                        expanded && styles.expanded,
                    )}>
                    <div>
                        <div
                            className={classNames(
                                styles.contentContainer,
                                contentContainerClassName,
                            )}
                            ref={ref}
                            style={height ? { height } : undefined}>
                            <div className={classNames(styles.widgetHeader, headerClassName)}>
                                {renderHeader}
                            </div>
                            <div className={classNames(styles.widgetContent, contentClassName)}>
                                {children}
                                {loading && <Loading />}
                            </div>
                        </div>
                    </div>
                </div>
            );
        },
    );

export default CasinoWidgetContainer;
